import i18n from '@cdo/locale';

// Same list as CourseOfferingCategories in sharedCourseConstants but with translated strings
export const translatedCourseOfferingCategories = {
  pl_self_paced: i18n.courseOfferingSelfPacedPl(),
  pl_virtual: i18n.courseOfferingVirtualPl(),
  pl_other: i18n.courseOfferingOtherPl(),
  full_course: i18n.courseOfferingFullCourse(),
  csf: i18n.courseOfferingCSF(),
  csc: i18n.courseOfferingCSC(),
  maker: i18n.courseOfferingMaker(),
  aiml: i18n.courseOfferingAIML(),
  hoc: i18n.courseOfferingHOC(),
  csf_international: i18n.courseOfferingCSFInternational(),
  math: i18n.courseOfferingMath(),
  twenty_hour: i18n.courseOfferingTwentyHour(),
  other: i18n.courseOfferingOther()
};
